import { CheckboxLabelled, IconCaretDown, IconCaretUp, InputMessage, typographyRem } from '@by-miles/bymiles-styles'
import React, { useState } from 'react'

import { useAccordionContextProvider } from '../../../../shared/AccordionV2/Accordion'
import { AccordionBody } from '../../../../shared/AccordionV2/AccordionBody'
import { AccordionHeader } from '../../../../shared/AccordionV2/AccordionHeader'
import { AccordionItem } from '../../../../shared/AccordionV2/AccordionItem'
import { CategoryPickerAccordionStyle } from './CategoryPickerAccordion'
const { h5: H5 } = typographyRem

interface SectionProps<T> {
  label: string
  value: T
}

interface CategoryPickerAccordionProps<T> {
  title: string
  sections: SectionProps<T>[]
  preFilled?: T[]
  onClick: (value: T[]) => void
  icon?: React.ReactNode
  error?: string
}

export const CategoryPickerAccordion = <T extends unknown>({
  title,
  sections,
  preFilled,
  icon,
  onClick,
  error,
}: CategoryPickerAccordionProps<T>) => {
  const [categoryError, setCategoryError] = useState<string>(error || '')
  const [selected, setSelected] = useState<T[]>(preFilled || [])

  const { expanded } = useAccordionContextProvider({ index: title })

  const handleCheckboxClick = (value: T) => {
    setCategoryError('')
    const updatedSelected = selected.includes(value) ? selected.filter(item => item !== value) : [...selected, value]
    setSelected(updatedSelected)
    onClick(updatedSelected)
  }

  return (
    <CategoryPickerAccordionStyle>
      <div className="category-error-container">
        {categoryError && <InputMessage className="category-error-message" position="top" message={categoryError} />}
      </div>
      <AccordionItem index={title}>
        <div className="category-picker-container">
          <AccordionHeader index={title} closeOnOpen>
            <div className="option-card">
              <div className="option-card-section">
                {icon && <div className="option-card-icon">{icon}</div>}
                <H5 className="option-card-title">{title}</H5>
              </div>
              <div className="option-card-section">
                {selected.length > 0 && <div className="option-card-notification">{selected.length}</div>}
                <div className="icon-container">{expanded ? <IconCaretUp /> : <IconCaretDown />}</div>
              </div>
            </div>
          </AccordionHeader>
          <AccordionBody index={title}>
            <div className="section-container">
              {sections.map(({ label, value }) => (
                <div key={label} className="section-content-wrapper">
                  <CheckboxLabelled
                    label={label}
                    dataCy={`${label.replace(' ', '-')}-checkbox-label`}
                    value={value}
                    onClick={handleCheckboxClick}
                    preFilled={selected?.includes(value) || false}
                  />
                </div>
              ))}
            </div>
          </AccordionBody>
        </div>
      </AccordionItem>
    </CategoryPickerAccordionStyle>
  )
}
